export default "__VITE_ASSET__B7jYiZfv__"